var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bootcamps-list-component',{attrs:{"url":_vm.url_get,"is_super_admin":_vm.is_super_admin}}),_vm._v(" "),(_vm.is_super_admin)?_c('createbootcamp-component',{attrs:{"get_url":_vm.url_get},on:{"onsaved":_vm.refreshBootcamps}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }